<template>
    <form class="row g-3" ref="form">
        <div class="col-md-5">
            <label for="name" class="form-label fw-bold">{{ $t("commodity.name") }}</label>
            <input type="text" class="form-control" id="name" v-model="localCommodity.name" required>
        </div>
        <div class="col-md-2">
            <label for="quantity" class="form-label fw-bold">{{ $t("commodity.quantity") }}</label>
            <input type="text" class="form-control" id="quantity" v-model="localCommodity.quantity" required>
        </div>
        <div class="col-md-2">
            <label for="unit" class="form-label fw-bold">{{ $t("commodity.unit") }}</label>
            <select id="unit" class="form-select" v-model="localCommodity.unit" required>
                <option
                    v-for="unit in commodityUnits"
                    :key="unit.id"
                    :value="unit.id"
                >
                    {{ unit.name }}
                </option>
            </select>
        </div>
        <div class="col-md-3">
            <label for="note" class="form-label">{{ $t("commodity.note") }}</label>
            <textarea class="form-control" rows="1" id="note" v-model="localCommodity.note"></textarea>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            commodity: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                localCommodity: {...this.commodity},
                commodityUnits: [],
            }
        },
        created() {
            this.getCommodityUnit();
        },
        methods: {
            validateData() {
                if (this.$refs.form.checkValidity() === false) {
                    this.$refs.form.reportValidity();
                    return false;
                }
                return true;
            },
            submitForm() {
                if (!this.validateData()) return;
                    return this.localCommodity;
            },
            getCommodityUnit() {
                this.$store.getters.api.get(`/${this.$route.params.slug}/commodity-units`)
                .then(response => {
                    this.commodityUnits = response.data;
                })
                .catch(error => {
                    console.error("Error loadind commodity units", error)
                });
            },
        },
        watch: {
            commodity: {
                handler(newVal) {
                    this.localCommodity = { ...newVal };
                },
                immediate: true
            }
        }
    }
</script>